import * as Yup from 'yup'
import { type DropdownMenuOption } from './dropdownMenuTypes'
import type { FlagKey } from './flagTypes'

export const FORM_FIELD_TYPES = {
  component: 'component',
  text: 'text',
  number: 'number',
  boolean: 'boolean',
  select: 'select',
  selectCustom: 'DropdownMenu',
  radio: 'radio',
  radioSelect: 'radioSelect',
  textarea: 'textarea',
  yesOrNo: 'yesOrNo',
  inputRange: 'inputRange',
  inputCustom: 'inputCustom',
  aiSalaryWidget: 'aiSalaryWidget',
} as const

export type FormFieldType =
  (typeof FORM_FIELD_TYPES)[keyof typeof FORM_FIELD_TYPES]

export interface FormField {
  name: string
  component?: Component
  componentType: FormFieldType
  label: string
  subLabel?: string
  placeholder?: string
  required?: boolean
  customValidator?: (value: any) => boolean | string
  rules: Yup.Schema
  defaultValue?: any
  value?: Ref<any>
  displayValue?: Ref<any>
  children?: { tag: string; text: string; [key: string]: any }[]
  onUpdate: (value: any) => void | Promise<void>
  checkShouldShow?: () => boolean
  componentProps?: {
    options?:
      | DropdownMenuOption[]
      | (() => DropdownMenuOption[] | Promise<DropdownMenuOption[]>)
    onClick?: () => void
    [key: string]: any
    placeholder?: string
    disabled?: boolean | (() => boolean)
  }
  url?: string
  flags?: FlagKey[]
  helpText?: string
  helpTitle?: string
  fillValue?: ComputedRef<string>
  candidateVisible?: boolean
  id?: string
  type?: string
  [key: string]: any
}

export interface FormDisplayComponent {
  name: string
  label: string
  [key: string]: any
}

export interface FormSection {
  id: string
  label?: string
  description?: string
  fields: FormField[]
  displayComponents?: FormDisplayComponent[]
  variant?: DynamicFormVariant
  numbered?: boolean
}

export interface FormStep {
  id: string
  title: string
  description?: string
  sections: FormSection[]
  variant?: DynamicFormVariant
}

export interface FormDefinition {
  id: string
  name: string
  steps: FormStep[]
  variant?: DynamicFormVariant
}

export enum DynamicFormVariant {
  Grid = 'grid',
  Vertical = 'vertical',
  Full = 'full',
}

export enum FormStatus {
  Incomplete = 'incomplete',
  InProgress = 'in_progress',
  Complete = 'complete',
}
